export default __webpack_public_path__ + "static/media/9.5f0f4aa4.jpg";